import { render } from "./SalaryIntro.vue?vue&type=template&id=57bda640&scoped=true"
const script = {}

import "./SalaryIntro.vue?vue&type=style&index=0&id=57bda640&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bda640"]])

export default __exports__